import { Component, ElementRef,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from '../services/pageviewsettings.service';

import { forkJoin } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import * as Globals from '../../globals';

  declare let analytics: any;


interface PageSettings {
  backgroundimage: string;
  choosesectionbgcolor: string;
  fontsize: string;
  title: string;
  subtitle: string;
  // plans: Plan[];
  whyHusky: { title: string; description: string }[];
}

interface broadbandPlan {
  planName: string;
  provider: string;
  disclosure: string;
  monthlyPrice: string;
  monthlyPriceNote: string;
    additionalFees: {
    label: string;
    amount: string;
  }[]
;
  governmentTaxes: string;
  speeds:  {
  download: string;
  upload: string;
  latency: string;
};
  dataIncluded: string;
  networkPolicyUrl: string;
  privacyPolicyUrl:string;
  support:  {
  phone: string;
  website: string;
}
  code: string;
}

interface CardDetail {
  text: string;
}

type planData = '5GB' | '25GB' | '35GB';
@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css']
})
export class PlansComponent {
	pageSettings: any = {};
  logoPrimaryImageUrl = '';
	logoSecondaryImageUrl = '';
  bannerimageurl = '';
	showCards = false;
	tenantId: any;
	affiliateId: any;
	collegeName: any;

  colors: { name: string; color: string }[] = [
    { name: "huskymobile", color: "#4b2e83" },
    { name: "osumobile", color: "#550000" },
    { name: "calmobile", color: "#00008b" },
    { name: "hushymobile", color: "#06402b" },
  ];

    plans: {
  id: number;
  url:string;
  data:string;
  name: string;
  price: number;
  description: string;
  subText: string;
  features: { title: string; description?: string }[]; // optional description
  highlight: boolean;
}[] = []
  plansdata:any
  plansarray:any[]=[]
  images = {
    background: '',
    banner: '',
    
  };
  plansdata2: any;
  broadbandLabelData: any[]=[];
  selectedPlanName: any;
  broadbanddata: any[]=[];
  // broadbandplans: { id: number; planName: string; provider: string; disclosure: string; monthlyPrice: string; monthlyPriceNote: string; additionalFees: { label: string; amount: string; }[]; governmentTaxes: string; speeds: { download: string; upload: string; latency: string; }; dataIncluded: string; networkPolicyUrl: string; privacyPolicyUrl: string; support: { phone: string; website: string; }; code: string; }[]=[];
 

   ;
  defaultImages = {
    background: '/api/assets/affiliate/1/tenant/1/images/landing-bg.jpg',
    banner: 'assets/landingpageplaceholderimage.png',
     logo: 'assets/schooldarklogo.png'
  };
  
  customerType: string = 'student';
	loadeddata: any;
	tenant: TenantService;
  guid:any

  tenantName: string = window.location.href.split('/')[3]; // TODO: Find a better way to do this.
   @ViewChild('carousel', { static: false }) carouselRef!: ElementRef;
   activeIndex = 0;
    scrollToCard(index: number) {
    const carousel = this.carouselRef.nativeElement as HTMLElement;
    const cardWidth = carousel.children[0].clientWidth + 16; // 16 = spacing
    carousel.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
    this.activeIndex = index;
  }
   getDotClass(i: number) {
    return {
      'w-3 h-3 rounded-full': true,
      'bg-purple-500': this.activeIndex === i,
      'bg-gray-300': this.activeIndex !== i
    };
  }

  getPlanUrl (planId: number) {
    switch (this.tenantId ) {
      case 1: 
        switch (planId) {
          case 1 : return 'https://husky-student.app.collegiatemobile.com/prepaid?planOfferingId=poff_Bi5piRzaPDwdGulR'
          case 2 : return 'https://husky-student.app.collegiatemobile.com/prepaid?planOfferingId=poff_paxWTgwXdqdDurHT';
          case 3 : return 'https://husky-student.app.collegiatemobile.com/prepaid?planOfferingId=poff_D78lFocgq5QKU1uI';
          default: return '';
        }
      case 2: 
        switch (planId) {
          case 1 : return 'https://bears-student.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_2DFPQMG849WCYIDR'
          case 2 : return 'https://bears-student.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_NPODWMLUK0U1JPHL';
          case 3 : return 'https://bears-student.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_GEFE5AM1MVDXFNY1';
          default: return '';
        }
      case 3: 
        switch (planId) {
          case 1 : return 'https://beavs-student.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_98QNVLBIN7XAKVNP'
          case 2 : return 'https://beavs-student.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_BHIOQM8AUDPT2Z9V';
          case 3 : return 'https://beavs-student.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_4YQV0IBBZDO2QJVD';
          default: return '';
        }
      default: return '';

    }
  }

	constructor(private router: Router, private settingsService: PageviewsettingsService, 
			private route: ActivatedRoute,  private tenantService: TenantService) {
		this.tenant = tenantService;
	}

  ngAfterViewInit() {
    const carousel = this.carouselRef.nativeElement as HTMLElement;
  

    // Listen to scroll events
    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const cardWidth = carousel.children[0].clientWidth + 16; // 16px gap (space-x-4)
      const index = Math.round(scrollLeft / cardWidth);
      this.activeIndex = index;
    });
    
  }
  ngOnInit() {

    this.collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';


      this.settingsService.getCollegetenantcode(this.collegeName).subscribe(data => {
      this.tenantId = parseInt(data.result.id)
      this.affiliateId=data.result.affiliateId

       this.loadPageSettings()
      //  this.settingsService.getCollegeImages1(collegeName,this.tenantId ).subscribe();
       this.settingsService.background$.subscribe(bg => this.images.background = bg);
      // this.updatePageContent();
    });
  } 
  loadPageSettings() {
 
      this.settingsService.getPageViewSettings(this.affiliateId,this.tenantId).subscribe(data => {
      this.loadeddata = data.result; 
this.guid=this.loadeddata.ActiveGiveawayEvent
      
      this.plans= [
      {
        id: 3,
        name: 'Student Unlimited',
        data:'35GB',
        url: this.getPlanUrl(3),
        price: 35,
        description: 'Taxes & Fees Included',
        subText: 'Built for power users, travelers, and students on the move.',
        highlight: true,
        features: [
          { title: '<b>Unlimited Data</b><br>25GB of high speed data*' },
          { title: '<b>Up to 15GB Hotspot Data Included</b>' },
          { title: '<b>3GB of International Data Roaming*</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? 'Giveback' : this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
        ]
      },
      {
        id: 2,
        name: 'Student Plus',
        url: this.getPlanUrl(2),
        data:'25GB',
        price: 25,
        description: 'Taxes & Fees Included',
        subText: 'Ideal for students juggling lectures, socials, and side hustles.',
        highlight: false,
        features: [
          { title: '<b>Unlimited Data</b><br>15GB of high speed data*' },
          { title: '<b>Up to 10GB Hotspot Data Included</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? 'Giveback' : this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
        ]
      },
      {
        id: 1,
        name: 'Student Basic',
        url: this.getPlanUrl(1),
        data:'15GB',
        price: 15,
        description: 'Taxes & Fees Included',
        subText: 'Great value for everyday use.',
        highlight: false,
        features: [
          { title: '<b>5GB of High-Speed Data</b>'},
          { title: '<b>Up to 5GB Hotspot Data Included</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? 'Giveback' : this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
        ]
      }
    ];        
  
  });
  }

 
  data: planData[] = ['5GB', '25GB', '35GB'];
  selectedData: number | null = null;




broadbandplans:  broadbandPlan = {
   
     
    planName: 'Student Basic',
    provider: 'Husky Mobile',
    disclosure: 'Mobile Broadband Consumer Disclosure',
    monthlyPrice: '15.00',
    monthlyPriceNote: 'This Monthly Price is an introductory rate. Length of Intro Period: 3 Months. Regular Monthly Price: $25.00',
    additionalFees: [
      { label: 'Provider Monthly Fees', amount:'None' },
      { label: 'One-time Purchase Fees', amount: 'None' },
      { label: 'Early Termination Fee', amount: 'None' },
      { label: 'Government Taxes', amount: 'Included' },
    ],
    governmentTaxes: 'There may be additional billing discounts available.',
    speeds: {
      download: '79-357 Mbps',
      upload: '6-30 Mbps',
      latency: '17-32 ms',
    },
    dataIncluded: '5 GB',
    networkPolicyUrl: 'https://www.huskymobile.com/transparence-disclosure/',
     privacyPolicyUrl: 'https://moxee-customer-agreements.s3.us-east-2.amazonaws.com/privacy-policy/Moxee+Privacy+Policy+2025-06-26.pdf',
    support: {
      phone: '(800) 683-7392',
      website: 'https://www.huskymobile.com/',
    },
    code: 'Learn about the terms used on this label. Visit the Federal Communications Commission’s Consumer Resource Center. ',
  }
       
  highlightFirstBold(text: string): string {
  const index = text.indexOf(' ');
  if (index === -1) return `<strong>${text}</strong>`;
  return `<strong>${text.slice(0, index)}</strong>${text.slice(index)}`;
}

  


  
 

  toggleCards() {
    this.showCards = true
  
    this.fetchBroadbandFactLabels()
   
  }
  updatePageContent() {

    const customer = this.customerType || 'student';
  if (!this.plansdata?.planDetails || this.plansdata.planDetails.length === 0) return;
const titleMap: Record<string, string> = {
  student: this.loadeddata.studentmainsectiontitle	,
  // faculty: 'Choose Your Student Plan',
  alumni: this.loadeddata.alumnimainsectiontitle
};

const subtitleMap: Record<string, string> = {
  student: this.loadeddata.studentmainsectionsubtitle,
  faculty: 'Flexible plans for academic professionals',
  alumni: this.loadeddata.alumnimainsectionsubtitle
};
  const plans = this.plansdata.planDetails.map((plan: any, index: number) => {
   
    return {
      id: plan.mobilePlanId,
      plancode: plan.planCode,
      name: plan.name,
      price: plan.consumerPrice/100,
      talk: plan.cardDetails?.[1]?.text ?? '',
      text: plan.cardDetails?.[2]?.text ?? '',
      data:plan.cardDetails?.[0]?.text ?? '',
      wifi: plan.cardDetails?.[3]?.text ?? '',
      mobiledata: plan.cardDetails?.[4]?.text ?? '',
      vedio: plan.cardDetails?.[5]?.text ?? '',
      offer: plan.cardDetails?.[6]?.text ?? '',
      contract: plan.cardDetails?.[7]?.text ?? '',
      internationationaltexts: index === 2 && plan.cardDetails?.[7]?.text ? '✔ ' + plan.cardDetails?.[7]?.text : '',
      internationationaldata: index === 2 && plan.cardDetails?.[8]?.text ? '✔ ' + plan.cardDetails?.[8]?.text : '',
      buttonname: ['Get Basic', 'Get Standard', 'Get Premium'][index] ?? 'Get Plan',
      
    };
  });



  const sharedSettings = {
    backgroundimage: this.loadeddata?.backgroundimage ?? '',
    choosesectionbgcolor: this.loadeddata?.choosesectionbgcolor ?? '',
    fontsize: this.loadeddata?.fontsize ?? '',
   title: titleMap[customer],            // override here
  subtitle: subtitleMap[customer],
    plans,
    whyHusky: [
      { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et.' },
      { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et' },
      { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et' },
      { backgroundcolor: '#4b2e83' }
    ]
  };

  this.pageSettings = sharedSettings;
  this.plans = plans;


}

  selectData(dataKey:any): void {
  // this.selectedData = dataKey;
this.selectedData = this.selectedData === dataKey ? null : dataKey;

  console.log(this.selectedData)
  this.showCards=true
  

    this.fetchBroadbandFactLabel(this.selectedData)
}

  fetchBroadbandFactLabel(planId: any) {
  this.settingsService.getbroadbandplans(planId).subscribe((labelData) => {
    this.broadbandLabelData = labelData.result;
  
  });
}
//  for backup: if toggling is needed
fetchBroadbandFactLabels() {
  const planIds = [1, 2, 3]; // Replace with your actual plan IDs
  const requests = planIds.map(id => this.settingsService.getbroadbandplans(id));

  forkJoin(requests).subscribe(results => {
    this.broadbanddata= results.map(res => res.result);
    console.log(this.broadbandLabelData);
  });
}



  selectPlan(plancode: any,value:any) {

if(value =='cardhighlighted'){
     this.selectedPlanName = plancode; 
    console.log(plancode)

    analytics.track(plancode)

     
}
   
   
 if( value =='buttonclicked')
  {
    analytics.track(` ${plancode} redirected to moxee site` )
    const url = ` ${plancode}`
     window.location.href = url;  
   
}

  
  
  }
  trackevent(event:any){
   
    analytics.track(event)
 
  }


}



